import React, { useEffect, useState } from "react";
import s from "./Users.module.scss";
import Card from "../../../../global components/Card/Card";
import Table from "./Local component/Table";
import useSWR from "swr";
import { UseAuthToken } from "../../../../libs/api/userSession";
import { parseClientError, swrFetcher } from "../../../../libs/api/Endpoints";
import { Skeleton } from "antd";
import Unauthorised from "../../../../global components/Unauthorised";
import CardFilter from "./Local component/Cards/Card";
function Subscribers() {
  const token = UseAuthToken();
  const [filters, setFilters] = useState<"" | "verified" | "unverified">(
    ""
  );
  const [filter, setFilter] = useState("7");
  const { data, error, isLoading } = useSWR<
    {data:{ total: number; verified: number; unverified: number; newInRange: number }},
    any,
    any
  >(
    token
      ? [
          "api/admin/newsletter/metrics",
          token,
          { growthInDays: filter },
        ]
      : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      retryOnError: false,
    }
  );
  const [unauthorised, setUnauthorised] = useState<
    boolean | { title: string; message: string }
  >(false);
  const handleFilter = (value: string) => {
    setFilter(value);
  };
  useEffect(() => {
    if (error) {
      const e = parseClientError(error);
      if (e.statusCode === 403) {
        setUnauthorised(true);
      } else {
        setUnauthorised({
          title: "Error",
          message: e.message || "Something went wrong",
        });
      }
    }
  }, [error]);
  return (
    <div className={s.wrapper}>
      <div className={s.titles}>
        <h3 className={s.title}>Subscribers</h3>
        <h4 className={s.subtitle}>
          Manage and track all subscriber information{" "}
        </h4>
      </div>
      <div className={s.cards}>
        {unauthorised ? (
          typeof unauthorised === "boolean" ? (
            <div className={s.cardError}>
              <Unauthorised />
            </div>
          ) : (
            <div className={s.cardError}>
              <Unauthorised error={unauthorised} />
            </div>
          )
        ) : (
          <>
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilters("")}
                label="Total Subscribers"
                stat={data?.data.total || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilters("verified")}
                label="Verified Subscribers "
                stat={data?.data.verified || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilters("unverified")}
                label="Unverified Subscribers"
                stat={data?.data.unverified || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <CardFilter
                handleFilters={handleFilter}
                cardTitle="New Subscribers"
                cardStat={data?.data.newInRange || 0}
              />
            )}
          </>
        )}
      </div>
      <Table filters={filters} />
    </div>
  );
}

export default Subscribers;
